import { ColDef } from 'ag-grid-community';

export const importColumnDefinitions: ColDef[] = [
  {
    headerName: 'Email',
    field: 'email',
    colId: 'email',
    minWidth: 125,
    width: 125,
  },
  {
    headerName: 'First Name',
    field: 'firstName',
    minWidth: 125,
    width: 125,
  },
  {
    headerName: 'Last Name',
    field: 'lastName',
    minWidth: 125,
    width: 125,
  },
  {
    headerName: 'SSO',
    field: 'sso',
    colId: 'sso',
    minWidth: 125,
    width: 125,
  },
  {
    headerName: 'Active',
    field: 'activeFlag',
    minWidth: 125,
    width: 125,
  },
  {
    headerName: 'Client',
    field: 'clientName',
    minWidth: 125,
    width: 125,
  },
  {
    headerName: 'Role',
    field: 'roleName',
    minWidth: 125,
    width: 125,
  },
  {
    headerName: 'Expiration Date',
    field: 'expirationDate',
    minWidth: 125,
    width: 125,
  },
  {
    headerName: 'Assignment Type',
    field: 'assignmentType',
    minWidth: 125,
    width: 125,
  },
  {
    headerName: 'Assignment',
    field: 'assignments',
    minWidth: 125,
    width: 125,
  },
  {
    headerName: 'Privileges',
    field: 'privileges',
    minWidth: 400,
  },
];
